export default {
	install(Vue) {
		const round = function(number, precision) {
			return Math.round(+number + 'e' + precision) / Math.pow(10, precision)
		}
		Vue.prototype.$screenRation = function() {
			var ratio = 0,
				screen = window.screen,
				ua = navigator.userAgent.toLowerCase()
			// if (window.devicePixelRatio !== undefined) {
			// 	ratio = window.devicePixelRatio
			// }
			if (ua.indexOf('msie') > 0) {
				// 妈的，垃圾ie浏览器 处理
				if (screen.deviceXDPI && screen.logicalXDPI) ratio = screen.deviceXDPI / screen.logicalXDPI
			}
			if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
				ratio = window.outerWidth / window.innerWidth
			}
			ratio = round(ratio, 1)
			if (ratio) ratio = Math.round(ratio * 100)
			if (ratio != 100) {
				alert('当前页面不是100%显示，\r\n1.请按键盘ctrl+0恢复100%显示标准，\r\n2.请按键盘F5刷新页面， \r\n以防页面显示错乱！')
			}
		}
	}
}
